import React from 'react';
import {Container} from './styles';
import PackageTitle from '../SubscriptionPackages/PackageTitle';
import PackagePrice from '../SubscriptionPackages/PackagePrice';
import subscriptionPlan from '../../content/subscriptionPlan.js';
import {dailyPackage} from '../../content/subscriptionPlan.js';

const ChosenPlan = ({plan, currency}) => {
  const chosenPlan =
    subscriptionPlan.find((pln) => pln.planType === plan) ??
    subscriptionPlan[2];

  // To test daily package in prod
  const chosenPack = plan === 'DAILY' ? dailyPackage[0] : chosenPlan;
  const {
    planType,
    title,
    subtitle,
    titleIcon,
    price,
    discountedPrice,
  } = chosenPack;

  return (
    <Container>
      <PackageTitle title={title} subtitle={subtitle} titleIcon={titleIcon} />
      <PackagePrice
        price={price}
        discountedPrice={discountedPrice}
        planType={planType}
        currency={currency}
      />
    </Container>
  );
};

export default ChosenPlan;
